'use strict'

function init() {
	$(document).ready(function() {
		if ($('.loadingScreen').length > 0) {
			window.setTimeout(function() {
				$('.loadingScreen').addClass('loadingScreen--loaded');
			}, 500);
			document.cookie = 'loadingScreenDisplayed=true; expires=Fri, 31 Dec 9999 23:59:59 GMT';
		}
	});
}

var LoadingScreen = {
	init: init
};

module.exports = LoadingScreen;